
/* eslint-disable */
import { useState } from 'react';

import { Handle } from 'reactflow';
import SideModal from '../components/SideModal';
import CustomRuleBox from '../components/customRuleBox';
import Header from '../components/Header';
import Handles from '../../cutomComponent/handles'
import { useForm } from "react-hook-form";


export default function BoxHeader({ event, children, isSideHandle, items_ul2, setShowConfirmation, cond, onConnect, modelType, typo, setNodes }) {
    const id = event.id;
    const type = event.data.value.type
    let ruleShow = true;

    if (type == "sms" || type == "mail" || type == "voice" || type == "whatsapp" || type == "wa_message") {
        ruleShow = false;
    }
    const SideHandel = () => {
        if (isSideHandle == "true" && ruleShow == true) {
            return <Handle
                type="source" position="right" className="main_point"
                id={`Sourcehandle-${id}`} onConnect={(params) => onConnect({ ...params, "cond": cond, datas: event })}
            />
        }
    }

    const SidePlusBox = () => {
        if (ruleShow == true) {
            return (
                <div className='start_btn_pos h-lg-100'>
                    <SideModal cond="all" id={`Sourcehandle-${id}`} event={event} items_ul2={items_ul2} typo={typo} modelType={modelType} />
                </div>
            )
        }
    }





    return (
        <>
            <Handles type='target' parent={event.data.value.parent} />
            <div className="main_flex_div">
                <div className="card position-relative p-0 box_width h-lg-100">
                    <Header id={id} label={event.data.label} setShowConfirmation={setShowConfirmation} type={type} />
                    {children}
                    <CustomRuleBox event={event} items_ul2={items_ul2} onConnect={onConnect} setNodes={setNodes} />
                </div>
                <SidePlusBox />
            </div>
            <SideHandel />
        </>
    )
}